import { Spinner, Tab } from "@blueprintjs/core"
import React, { useEffect, useMemo, useState } from "react"
import CustomCard from "components/Atoms/CustomCard"
import QueryBar from "components/Common/QueryBar"
import CustomVerticalTabs from "components/Organisms/CustomVerticalTabs"
import BackButton from "components/Templates/BackButton"
import { useSellableItemsSuggest } from "graphql/sellable-item/sellable-item.hooks"
import { useSearchFilter } from "hooks/searchFilterHooks"
import { getId } from "utils/custom.utils"
import StockRange from "../StockRange"
import ItemStockList from "./ItemStockList"
// import ItemsSuggest from "./ItemsSuggest";

const AddUpdateStock = () => {
  const [{ search, id }, setFilter] = useSearchFilter()

  const { data: suggest, loading } = useSellableItemsSuggest({ search, id })

  const items = useMemo(() => suggest?.allSellableItems ?? [], [suggest])

  const [tab, setTab] = useState(items?.[0])

  useEffect(() => {
    setTab(items?.[0])
  }, [items])

  return (
    <>
      <CustomCard>
        <div className="flex items-baseline ">
          <BackButton />
          <h4 className="mr-6 w-full text-center">
            <span className="vt-muted"> Sellable Item</span> -{" "}
            {tab?.name || "NA"}
          </h4>
        </div>
      </CustomCard>
      <div className="p-3">
        <CustomCard>
          <CustomVerticalTabs
            className="vt-sellable-item-tabs"
            selectedTabId={tab?.id}
            onChange={tab => {
              setTab(items?.find(i => getId(tab) === getId(i)))
            }}
          >
            <QueryBar
              className="mb-3 w-full"
              round={false}
              value={search}
              onChange={search => setFilter({ search })}
            />
            {loading ? (
              <section className="vt-items-loader">
                <Spinner />
              </section>
            ) : (
              tab &&
              items?.map(i => {
                let cs = 0,
                  os = 0,
                  hs = 0,
                  bs = 0,
                  rs = 0
                for (const stock of i.sellableStocks ?? []) {
                  cs += stock?.currentStockCount
                  hs += stock?.holdStockCount
                  os += stock?.offerStockCount
                  bs += stock?.bookedStockCount
                  rs += stock?.rejectedStockCount
                }

                return (
                  <Tab
                    className="w-full flex-col items-start"
                    key={i?.id}
                    title={
                      <>
                        <p className="mb-1">{i?.name}</p>
                        <StockRange hs={hs} os={os} cs={cs} bs={bs} rs={rs} />
                      </>
                    }
                    id={i?.id}
                    panel={
                      <ItemStockList key={i?.id} selectedItem={tab} item={i} />
                    }
                  />
                )
              })
            )}
          </CustomVerticalTabs>
        </CustomCard>
      </div>
    </>
  )
}

export default AddUpdateStock
